export default [
  { value: '36', text: 'Under 3ft' },
  { value: '48', text: '3-4ft' },
  { value: '59', text: '4-5ft' },
  { value: '60', text: '5\'0' },
  { value: '61', text: '5\'1' },
  { value: '62', text: '5\'2' },
  { value: '63', text: '5\'3' },
  { value: '64', text: '5\'4' },
  { value: '65', text: '5\'5' },
  { value: '66', text: '5\'6' },
  { value: '67', text: '5\'7' },
  { value: '68', text: '5\'8' },
  { value: '69', text: '5\'9' },
  { value: '70', text: '5\'10' },
  { value: '71', text: '5\'11' },
  { value: '72', text: '6\'0' },
  { value: '73', text: '6\'1' },
  { value: '74', text: '6\'2' },
  { value: '75', text: '6\'3' },
  { value: '76', text: '6\'4' },
  { value: '77', text: '6\'5' },
  { value: '78', text: '6\'6' },
  { value: '79', text: '6\'7' },
  { value: '80', text: '6\'8' },
  { value: '81', text: '6\'9' },
  { value: '82', text: '6\'10' },
  { value: '83', text: '6\'11' },
  { value: '85', text: 'Over 7ft' }
]
